import React from "react";
import { Col, Container, Row } from "reactstrap";
import showdown from 'showdown';
import CallToButton from "../components/CallToButton";
import FullPageImg from "../components/FullPageImg";
import Grid3Column from "../components/Grid3Column";
import Metadata from "../components/Metadata";
import OutdoorProperty from "../components/outdoorProperties";
import Youtubevideo from "../components/youtubeVideo";

const converter = new showdown.Converter();

const OutdoorkuechenPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Container className="body__main">
      <Metadata
        title={frontmatter.title}
        description={frontmatter.description}
      />
      <Row>
          <Col>
            <h1 className="mainheader">{frontmatter.heading}</h1>
          </Col>
      </Row>
      <Youtubevideo videoId="sPWpiQjuCkU"></Youtubevideo>
      <Row className="mb-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy1) }} />
          </Col>
      </Row>
      <CallToButton link="/kontakt/" linktext={frontmatter.calltobutton} />
        <FullPageImg image1={frontmatter.banner1.image1} />
        <Grid3Column
          theme="dark"
          callout1={frontmatter.grid1.callout1}
          callout2={frontmatter.grid1.callout2}
          callout3={frontmatter.grid1.callout3}
          image1_1={frontmatter.grid1.image1_1}
          image1_2={frontmatter.grid1.image1_2}
          image2_1={frontmatter.grid1.image2_1}
          image2_2={frontmatter.grid1.image2_2}
          image3_1={frontmatter.grid1.image3_1}
          image3_2={frontmatter.grid1.image3_2}
        />
      <Row className="mb-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy2) }} />
          </Col>
      </Row>
      <Row className="mt-4">
          <Col>
            <h2>{frontmatter.headlineoptions}</h2>
            <ul>
            {frontmatter.headlineoverview.map( element => (
              <li>{element.property}</li>
            ))}
            </ul>
            {frontmatter.options.map( prop => (
              <OutdoorProperty
              headline={prop.headline}
              properties={prop.properties}
              description={prop.description}
              image={prop.image}
              imagealt={prop.imagealt}
              image2={prop.image2}
              imagealt2={prop.imagealt2}
              image3={prop.image3}
              imagealt3={prop.imagealt3} />
              
            ))}
          </Col>
      </Row>
        <FullPageImg image1={frontmatter.banner2.image1} />
      <Row className="mt-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy3) }} />
          </Col>
      </Row>
      <CallToButton link="/kontakt/" linktext={frontmatter.calltobutton} />
    </Container>
  );
};

export default OutdoorkuechenPage;

export const OutdoorkuechenPageQuery = graphql`
  query OutdoorkuechenPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        templateKey
        title
        heading
        description
        calltobutton
        bodycopy1
        bodycopy2
        bodycopy3
        banner1 {
          image1 {
            image
          }
        }
        grid1 {
          callout1
          callout2
          callout3
          image1_1 {
            image
          }
          image1_2 {
            image
          }
          image2_1 {
            image
          }
          image2_2 {
            image
          }
          image3_1 {
            image
          }
          image3_2 {
            image
          }
        }
        banner2 {
          image1 {
            image
          }
        }
        headlineoptions
        headlineoverview {
          property
        }
        options {
          headline
          image
          image2
          image3
          imagealt
          imagealt2
          imagealt3
          properties {
            property
          }
          description
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/outdoorkuechen-page.js